let sentryImportPromise: Promise<typeof import("@sentry/react")> | undefined;
let sentryInitPromise: Promise<void> | undefined;

function shouldUseSentry() {
  return Boolean(import.meta.env.VITE_SENTRY_DSN);
}

function loadSentry() {
  if (!shouldUseSentry()) {
    return undefined;
  }

  sentryImportPromise ??= import("@sentry/react");

  return sentryImportPromise;
}

function getTracePropagationTargets() {
  const targets: Array<string | RegExp> = ["localhost"];

  try {
    targets.push(new URL(import.meta.env.VITE_API_URL).origin);
  } catch {
    targets.push(/^https:\/\/api\.novinhub\.com/);
    targets.push(/^https:\/\/apibeta\.novinhub\.com/);
  }

  return targets;
}

export function initSentry(history: unknown) {
  if (!shouldUseSentry() || sentryInitPromise) {
    return;
  }

  sentryInitPromise = loadSentry()!
    .then((Sentry) => {
      Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
          Sentry.reactRouterV5BrowserTracingIntegration({
            history: history as any,
          }),
          Sentry.replayIntegration(),
          Sentry.browserTracingIntegration(),
        ],
        tracesSampleRate: 0.1,
        tracePropagationTargets: getTracePropagationTargets(),
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      });
    })
    .catch(() => undefined);
}

export function captureSentryException(
  error: unknown,
  info?: Record<string, unknown>,
) {
  const sentry = loadSentry();

  if (!sentry) {
    return;
  }

  void sentry
    .then((Sentry) => {
      Sentry.captureException(error, {
        extra: info,
      });
    })
    .catch(() => undefined);
}
